//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MessageBox from '@/components/messageBox';

export default {
  name: 'WorkflowDetailEventTip',
  components: { MessageBox },
  methods: {
    jump() {
      try {
        this.$refs.messageBox.show({
          title: '提示',
          content: '此操作将不会保存已修改数据?',
          titleIconType: 'warning',
          needCancel: true,
          cancelAction: this.$refs.messageBox.close,
          confirmAction: () => {
            this.$refs.messageBox.close();
            this.$router.push({
              name: 'workflow-event-list',
            });
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
